import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";
import { getExperienceLabel } from "../pages/jobs/Jobs";
import SharePost from "./sharePost/SharePost";
import CodeHighlighter from "./CodeHighlighter";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const PublicModalView = ({ open, setOpen, type,activePost:passedPost, onReadsUpdate, onLikesUpdate, onCommentsUpdate }) => {
  const navigate=useNavigate()
  const [post, setPost] = useState(null);
  const [error, setError] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [followStatus, setFollowStatus] = useState({});
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingCommentId, setEditingCommentId] = useState(null);
  const [editComment, setEditingComment] = useState("");
  const [postOwner, setPostOwner] = useState(null);
  const [commentText, setCommentText] = useState("");
  const [postingComment, setPostingComment] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [postExpanded, setPostExpanded] = useState(false);

  // console.log("The passed post is:",post)
  const token = localStorage.getItem("access_token");
    const handleClose = () => {
    if (onReadsUpdate && post) {
      onReadsUpdate(post.id, post.reads);
    }
    setOpen(false);
    // Reset URL
    localStorage.removeItem('activePost');
    window.history.pushState({}, "", "/home");
  };
    useEffect(() => {
      if (type) {
        fetchComments();
      }
    }, [type]);
const handleLike = async () => {
  try {
    // Extract id and type from the type prop (e.g., "/post/97?type=image")
    const [pathname, queryString] = type.split("?"); // 'type' is your prop
    const id = pathname.split("/")[2]; // get '97' from '/post/97'
    const params = new URLSearchParams(queryString);
    const extractedType = params.get("type"); // get 'image'

    // Make API call
    const res = await axios.post(
      `${BASE_URL}/user/like/`,
      { type: extractedType, id },
      { headers: { Authorization: `Bearer ${token}`, "x-api-key": process.env.REACT_APP_X_API_KEY } }
    );

    if (res.data?.status) {
      const liked = res.data.status === "liked";

      // Calculate new like count
      const currentLikes = post.total_likes ?? 0;
      const newLikeCount = liked ? currentLikes + 1 : Math.max(currentLikes - 1, 0);

      // Update only total_likes in post state
      setPost((prev) => ({
  ...prev,
  is_liked: liked,
  total_likes: newLikeCount,
}));

      // Update parent component
      if (onLikesUpdate) {
        onLikesUpdate(post.id, liked, newLikeCount);
      }

    }
  } catch (error) {
    console.error("Error liking post:", error);
  }
};


  const fetchComments = async () => {
    try {
          // Extract id and type from the type prop (e.g., "/post/97?type=image")
    const [pathname, queryString] = type.split("?"); // 'type' is your prop
    const id = pathname.split("/")[2]; // get '97' from '/post/97'
    const params = new URLSearchParams(queryString);
    const extractedType = params.get("type"); // get 'image'
      // setCommentLoading(true);
      const res = await axios.get(`${BASE_URL}/user/comment/`, {
        params: { type: extractedType, id: id },
        headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY },
      });

      if (res.data?.results) {
        const mappedComments = res.data.results.map((c) => ({
          id: c.id,
          author: c.user.name,
          avatar: c.user.profile_picture,
          text: c.text,
          userId: c.user.id,
        }));
        setComments(mappedComments);
        setPostOwner(res.data.post_owner);
        setPost((prev) => ({
  ...prev,
  total_comments: prev?.total_comments ? prev?.total_comments + 1 : 1,
}));
      }
    } catch (error) {
      console.error("Error fetching comments:", error);
    } finally {
      // setCommentLoading(false);
    }
  };
// Update handleComment function
const handleComment = async () => {
  const [pathname, queryString] = type.split("?");
  const id = pathname.split("/")[2];
  const params = new URLSearchParams(queryString);
  const extractedType = params.get("type");
  
  try {
    setPostingComment(true); // Use separate state
    await axios.post(
      `${BASE_URL}/user/comment/`,
      { type: extractedType, id: id, commit: commentText },
      { headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY } }
    );
    setCommentText("");
    fetchComments();

    // Update parent component
    if (onCommentsUpdate) {
      const newCommentCount = (post.total_comments ?? 0) + 1;
      onCommentsUpdate(post.id, newCommentCount);
    }
  } catch (error) {
    console.error("Error posting comment:", error);
  } finally {
    setPostingComment(false); // Use separate state
  }
};
  const handleEditComment = (comment) => {
    setEditingCommentId(comment.id);
    setEditingComment(comment.text);
  };
    const saveEditComment = async (id) => {
    try {
      await axios.patch(
        `${BASE_URL}/user/comment/`,
        { id, commit: editComment },
        { headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY } }
      );
      setEditingCommentId(null);
      fetchComments();
    } catch (error) {
      console.error("Error editing comment:", error);
      toast.error("Failed to edit comment");
    }
  };
  const handleDeleteComment = async (commentId) => {
    try {
      await axios.delete(`${BASE_URL}/user/comment/`, {
        data: { id: commentId },
        headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY },
      });
      fetchComments();
      toast.success("Comment deleted");

      // Update parent component
      if (onCommentsUpdate) {
        const newCommentCount = Math.max((post.total_comments ?? 1) - 1, 0);
        onCommentsUpdate(post.id, newCommentCount);
      }
    } catch (error) {
      console.error("Error deleting comment:", error);
      toast.error("Failed to delete comment");
    }
  };
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden"; // remove scroll
      // document.body.style.height = "100vh";    // lock height
    } else {
      document.body.style.overflow = "";
      document.body.style.height = "";
    }

    return () => {
      document.body.style.overflow = "";
      document.body.style.height = "";
    };
  }, [open]);

  // useEffect(() => {
  //   if (isOpen) {
  //     document.body.classList.add("overflow-hidden");
  //   } else {
  //     document.body.classList.remove("overflow-hidden");
  //   }

  //   return () => {
  //     document.body.classList.remove("overflow-hidden");
  //   };
  // }, [isOpen]);
const fetchCurrentUser = async () => {
  if (!token) return;

  try {
    const res = await axios.get(
      `${BASE_URL}/user/profile/create-profile/`,
      {
        headers: { Authorization: `Bearer ${token}` , "x-api-key": process.env.REACT_APP_X_API_KEY,},
      }
    );

    if (res?.data?.data) {
      setCurrentUser(res.data.data);
      setCurrentUserId(res?.data.data?.user);
    }
  } catch (err) {
    console.error("Failed to fetch current user", err);
  }
};

useEffect(() => {
  if (!token) return;

  fetchCurrentUser();
}, [token]);

useEffect(() => {
  // ✅ CASE 1: passed post from props
if (passedPost) {
  const normalized = {
    ...passedPost,
    user_profile: passedPost.user,
    type: passedPost.type || passedPost.post_type || "post",
    total_likes: passedPost.like_count ?? 0,
    total_comments: passedPost.comment_count ?? 0,
    latest_comment: passedPost.comments?.[0] || null,
    reads: passedPost.reads ?? 0,
  };

  setPost(normalized);
  setLoading(false); // ✅ FIX
  // return;
}


  // ✅ CASE 2: open via URL
  if (!type) return;

  const parsedUrl = new URL(type, window.location.origin);
  const postId = parsedUrl.pathname.split("/").pop();
  const postType = parsedUrl.searchParams.get("type");

  const fetchPostData = async () => {
    try {
      setLoading(true);

      const res = await fetch(
        `${BASE_URL}/user/publication/home/?id=${postId}&type=${postType}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
        }
      );

      if (!res.ok) {
        throw new Error(`Server responded with ${res.status}`);
      }

      const data = await res.json();

      setPost((prev) => ({
        ...data,
        user_profile: data.user_profile || prev?.user_profile,
        type: prev?.type || data.type || data.post_type || "post",
        post_type: prev?.post_type || data.post_type,
        total_likes: data.total_likes ?? 0,
        total_comments: data.total_comments ?? 0,
        latest_comment: data.comments?.[0] || null,
        reads: data.reads ?? 0,
      }));
    } catch (err) {
      console.error(err);
      setError("Failed to load post.");
    } finally {
      setLoading(false);
    }
  };

  fetchPostData();
}, [passedPost, type, token]);


  useEffect(() => {
    const fetchFollowings = async () => {
      if (!token || !currentUserId) return;
      try {
        const res = await axios.get(
          `${BASE_URL}/user/follow-unfollow/follow/`,
          {
            headers: { Authorization: `Bearer ${token}`, "x-api-key": process.env.REACT_APP_X_API_KEY },
          }
        );
        const followedItems = res.data?.results || [];
        const statusMap = {};
        followedItems.forEach((item) => {
          const userProfile = item.follow_user_profile;
          if (userProfile?.id) statusMap[String(userProfile.id)] = true;
        });
        setFollowStatus(statusMap);
      } catch (err) {
        console.error("Failed to fetch followings", err);
      }
    };
    
    fetchFollowings();
  }, [token, currentUserId]);

  const handleFollowToggle = async (userId) => {
    const stringUserId = String(userId);
    const isFollowing = followStatus[stringUserId];
    
    if (!token) {
      toast.error("Please login to follow users");
      return;
    }

    try {
      if (isFollowing) {
        const res = await axios.delete(
          `${BASE_URL}/user/follow-unfollow/follow/`,
          {
            headers: { Authorization: `Bearer ${token}`, "x-api-key": process.env.REACT_APP_X_API_KEY },
            data: { id: userId },
          }
        );
        if (
          res.status === 204 ||
          res.data?.message === "Successfully unfollowed."
        ) {
          setFollowStatus((prev) => ({ ...prev, [stringUserId]: false }));
          toast.success("Unfollowed successfully");
        }
      } else {
        const res = await axios.post(
          `${BASE_URL}/user/follow-unfollow/follow/`,
          { id: userId },
          {
            headers: { Authorization: `Bearer ${token}`, "x-api-key": process.env.REACT_APP_X_API_KEY },
          }
        );
        if (res.data?.message === "Successfully followed") {
          setFollowStatus((prev) => ({ ...prev, [stringUserId]: true }));
          toast.success("Followed successfully");
        }
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to update follow status");
    }
  };

  const handleProfileClick = (user) => {
    if (!user || !user.id) return;
    
    // Since this is a modal, you might want to handle profile navigation differently
    // For now, we'll just close the modal and let parent handle navigation
    setOpen(false);
    
    // You could also pass a callback to parent to handle navigation
    // Example: if (onProfileNavigate) onProfileNavigate(user);
  };

const renderMedia = (post) => {
  // console.log("The post number 1 is:",post.type)
  if (post.type === "image" && post.image) {
    return (
    <div className="w-[90%] h-full rounded-[10px] overflow-hidden">
  <img
    src={post.image}
    alt="Post"
    className="w-full h-full object-cover"
  />
</div>

    );
  } else if (post.type === "video" && post.video) {
    return (
       <div className="w-[90%] h-full rounded-[10px] overflow-hidden">
   <video
        controls
        className="w-full h-full object-cover"
      >
        <source src={post.video} type="video/mp4" />
      </video>
       </div>
   
    );
  } else if (post.type === "post" && post.post_type !== "job" && post.post_type !== "normal") {
    return (
      <div className="p-4 border border-gray-300 rounded-lg max-w-2xl break-words">
        {post.title && <h3 className="text-lg font-semibold mb-2">{post.title}</h3>}
        {post.content && (
          <p>
            <strong>Content:</strong> {post.content}
          </p>
        )}
      </div>
    );
  } else if (post.type === "code") {
    return (
    <pre className="w-full h-[95vh]  text-gray-100 rounded-lg font-mono text-sm overflow-auto break-words whitespace-pre-wrap">
  {/* {post.code || "// No code"} */}
    <CodeHighlighter codeHtml={post.code} padding='p-8'/>
</pre>

    );
  } else if (post.upload_document) {
    const fileName = post.upload_document.split("/").pop();
    const ext = fileName.split(".").pop().toLowerCase();
    let fileTypeLabel = "Document";
    if (ext === "pdf") fileTypeLabel = "PDF Document";
    else if (["doc", "docx"].includes(ext)) fileTypeLabel = "Word Document";
    else if (["xls", "xlsx"].includes(ext)) fileTypeLabel = "Excel Spreadsheet";
    else if (["ppt", "pptx"].includes(ext)) fileTypeLabel = "PowerPoint Presentation";
    else if (ext === "txt") fileTypeLabel = "Text File";
    return (
      <div className="flex items-center gap-2 border border-gray-300 p-2 rounded-lg max-w-xs">
        <div className="flex-1">
          <div className="font-bold text-sm">
            {fileName.length > 20 ? fileName.slice(0, 20) + "..." : fileName}
          </div>
          <div className="text-xs text-gray-500">{fileTypeLabel}</div>
        </div>
      </div>
    );
  
  }
 else if (post.type === "normal") {
  return (
    <div className="p-6 bg-white rounded-xl border border-gray-200 shadow-sm w-full break-words 
                hover:shadow-md transition-shadow duration-200 min-h-screen max-h-screen overflow-y-auto">

      {post.title && (
        <h3 className="text-xl font-semibold text-gray-900 mb-3 pb-3 border-b border-gray-100">
          {post.title}
        </h3>
      )}
      {post.content && (
        <div 
          className="prose prose-gray max-w-none"
          dangerouslySetInnerHTML={{ __html: post.content }}
        />
      )}
    </div>
  );
}
   else if (post.post_type === "post" || post.post_type === "job") {
  return (
    <div className="p-6  shadow-sm w-full break-words hover:shadow-md transition-shadow duration-200 min-h-screen max-h-screen overflow-y-auto">

      {post.title && (
        <h3 className="text-xl font-semibold text-gray-900 mb-4">
          {post.title}
        </h3>
      )}
      
      {post.content && (
        <div className="mb-6 prose prose-gray max-w-none">
          {post.content}
        </div>
      )}
      
      {post.post_type === "job" && (
        <div className="mt-6 pt-6 border-t border-gray-100">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-3">
              <div>
                <span className="text-sm font-medium text-gray-500">Job Title</span>
                <p className="text-gray-900">{post.job_title}</p>
              </div>
              
              <div>
                <span className="text-sm font-medium text-gray-500">Company</span>
                <p className="text-gray-900">{post.company_name}</p>
              </div>
              
              <div>
                <span className="text-sm font-medium text-gray-500">Location</span>
                <p className="text-gray-900">{post.location}</p>
              </div>
              
              <div>
                <span className="text-sm font-medium text-gray-500">Remote</span>
                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${post.remote_allowed ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`}>
                  {post.remote_allowed ? "Yes" : "No"}
                </span>
              </div>
              
              <div>
                <span className="text-sm font-medium text-gray-500">Experience</span>
                <p className="text-gray-900">{getExperienceLabel(post.experience_level)}</p>
              </div>
            </div>
            
            <div className="space-y-3">
              <div>
                <span className="text-sm font-medium text-gray-500">Salary</span>
                <p className="text-gray-900">
                  {post.salary_min && post.salary_max 
                    ? `${post.salary_min} - ${post.salary_max} ${post.currency}`
                    : "Not specified"}
                </p>
              </div>
              
              {post.skills_list?.length > 0 && (
                <div>
                  <span className="text-sm font-medium text-gray-500">Skills</span>
                  <div className="flex flex-wrap gap-2 mt-1">
                    {post.skills_list.map((skill, index) => (
                      <span key={index} className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-blue-100 text-blue-800">
                        {skill}
                      </span>
                    ))}
                  </div>
                </div>
              )}
              
              {post.qualifications && (
                <div>
                  <span className="text-sm font-medium text-gray-500">Qualifications</span>
                  <p className="text-gray-900">{post.qualifications}</p>
                </div>
              )}
              
              <div>
                <span className="text-sm font-medium text-gray-500">Application</span>
                <div className="space-y-2 mt-2">
                  {post.application_email && (
                    <a href={`mailto:${post.application_email}`} className="block text-blue-600 hover:text-blue-800 hover:underline">
                      {post.application_email}
                    </a>
                  )}
                  {post.application_url && (
                    <a href={post.application_url} target="_blank" rel="noopener noreferrer" className="block text-blue-600 hover:text-blue-800 hover:underline">
                      Apply Online →
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
   else {
    return (
      <div className="p-5 bg-gray-50 rounded">
        No media available.
      </div>
    );
  }
};


  if (!open) return null;


  const parsedUrl = new URL(type, window.location.origin);
  const postId = parsedUrl.pathname.split("/").pop();
  const postType = parsedUrl.searchParams.get("type");

  if (loading) {
    return (
      <div
        className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
        onClick={() => setOpen(false)}
      >
        <div
          className="bg-white rounded-xl shadow-lg w-full max-w-4xl p-6 relative max-h-[90vh] overflow-y-auto"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            onClick={() => setOpen(false)}
            className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 z-10"
          >
            ✕
          </button>
          
          <div className="flex justify-center items-center h-64">
            <ClipLoader color="#3659d7ff" size={50} />
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div
        className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
        onClick={() => setOpen(false)}
      >
        <div
          className="bg-white rounded-xl shadow-lg w-full max-w-4xl p-6 relative max-h-[90vh] overflow-y-auto"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            onClick={() => setOpen(false)}
            className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 z-10"
          >
            ✕
          </button>
          
          <div className="text-red-500 p-5">{error}</div>
        </div>
      </div>
    );
  }

  if (!post) return null;

  const { user_profile = {} } = post;
  
  const shouldShowFollow =
    user_profile?.id &&
    currentUserId &&
    String(user_profile.id) !== String(currentUserId);

  return createPortal (
<div
  className="fixed inset-0 z-[100000] bg-black/50 flex items-center justify-center overflow-hidden"
  onClick={(e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  }}
>
  <div
    className="w-full h-full sm:w-screen sm:h-screen bg-white relative flex flex-col sm:flex"
    onClick={(e) => e.stopPropagation()}
  >
    {/* Close Button - Mobile optimized */}
    <button
      onClick={handleClose}
      className="cursor-pointer absolute top-3 left-3 sm:top-4 sm:left-4 w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-gray-200 rounded-full hover:bg-gray-300 z-10"
    >
      ✕
    </button>

    {/* Mobile: Changed flex direction for mobile */}
    <div className="flex flex-col sm:flex-row w-full h-full">
      {/* Media Container - Mobile: Full width, desktop: 9/12 */}
      <div className="w-full h-[60vh] sm:h-full sm:w-9/12 p-2 sm:p-4 overflow-hidden flex items-center justify-center bg-gray-50">
        {renderMedia(post)}
      </div>

      {/* Content Container - Mobile: Full width, desktop: 3/12 */}
      <div className="w-full sm:w-3/12 h-[40vh] sm:h-full flex flex-col bg-white overflow-hidden">
        
        {/* Scrollable content with mobile-specific padding */}
        <div className="flex-1 overflow-y-auto p-3 sm:pt-6 sm:px-4">
          {/* User Info - Mobile optimized */}
          <div className="flex items-center gap-3">
            <div className="relative cursor-pointer">
              <img 
                src={post.user_profile?.profile_picture} 
                alt="User" 
                className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl object-cover border-2 border-white shadow-sm" 
                onClick={()=>navigate(post?.type === 'job' || post?.type === "normal" ? `${currentUserId === post?.user?.id ? "/profile-view" : `/user-profile/${post?.user?.profile_id}`}` :`${currentUserId === post.user ? "/profile-view" : `/user-profile/${post?.user_profile?.id}`}`)}
              />
              <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-white"></div>
            </div>
            <div className="flex flex-col">
              <span className="font-semibold text-gray-900 text-sm sm:text-base">
                {post.user_profile?.name}
              </span>
            </div>
          </div>

          {/* Description - Mobile optimized */}
          <div className="mt-3 sm:mt-4 text-base sm:text-lg  text-gray-900 mb-2 break-words">
  {postExpanded || post.description?.length <= 120
    ? post?.description
    : post?.description?.slice(0, 120) + "..."}

  {post.description?.length > 120 && (
    <span
      onClick={() => setPostExpanded(!postExpanded)}
      className="text-blue-600 cursor-pointer ml-1 font-medium"
    >
      {postExpanded ? " Read less" : " Read more"}
    </span>
  )}
</div>
          {/* Action Bar - Mobile optimized spacing */}
          <div className="flex justify-between items-center mt-4 sm:mt-6 pt-4 sm:pt-6 border-t border-gray-100">
            <div className="flex gap-1 sm:gap-2 w-full">

              {/* LIKE - Mobile optimized */}
              <button
                className={`flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-1.5 sm:py-2 rounded-xl transition-colors flex-1 justify-center ${
                  post.is_liked 
                    ? "text-red-500 bg-red-50" 
                    : "text-gray-600 hover:bg-gray-100"
                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleLike();
                }}
              >
                <svg className="w-4 h-4 sm:w-5 sm:h-5" fill={post.is_liked ? "currentColor" : "none"} stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={post.is_liked ? "0" : "2"} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
                <span className="text-xs sm:text-sm font-medium truncate">
                  {post?.total_likes}
                </span>
              </button>

              {/* COMMENTS - Mobile optimized */}
              <button className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-1.5 sm:py-2 rounded-xl text-gray-600 hover:bg-gray-100 transition-colors flex-1 justify-center">
                <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
                <span className="text-xs sm:text-sm font-medium truncate">
                  Comments
                </span>
              </button>

              {/* SHARE - Mobile optimized */}
              <button   onClick={(e) => {
            e.stopPropagation();
            setShowShareModal(true);
          }} className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-1.5 sm:py-2 rounded-xl text-gray-600 hover:bg-gray-100 transition-colors flex-1 justify-center">
                <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
                </svg>
                <span className="text-xs sm:text-sm font-medium truncate">Share</span>
              </button>

            </div>
          </div>
  {showShareModal && (
      <SharePost
        postId={postId}
        postLink={type}
        onClose={() => setShowShareModal(false)}
        isTrue={true}
      />
    )}

          {/* Comments Section - Mobile optimized */}
          <div className="mt-4 sm:mt-6 pt-4 sm:pt-6 border-t border-gray-100">
            <h4 className="font-medium text-gray-900 mb-3 text-sm sm:text-base">
              Comments ({post?.total_comments})
            </h4>
            <div className="space-y-3 pr-1 sm:pr-2 mb-20 sm:mb-28">
              {comments?.length === 0 ? (
                <div className="text-center py-4">
                  <p className="text-xs sm:text-sm text-gray-500">No comments yet</p>
                </div>
              ) : (
                comments.map((c) => (
                  <div className="flex items-start gap-2 sm:gap-3" key={c.id}>
                    <img
                      src={c.avatar || currentUser?.profile_picture}
                      alt="User"
                      className="w-8 h-8 sm:w-9 sm:h-9 cursor-pointer rounded-full object-cover border border-gray-200 flex-shrink-0"
                      onClick={()=>navigate(`${currentUser?.id === c?.userId ? "/profile-view" : `/user-profile/${c?.userId}`}`)}
                    />

                    <div className="flex-1 min-w-0">
                      <div className="bg-gray-50 rounded-xl p-2 sm:p-3">
                        <div className="flex items-center justify-between mb-1">
                          <span className="font-medium text-xs sm:text-sm text-gray-900 truncate">
                            {c.author} {c.userId}
                          </span>


                          {(currentUser?.id === c.userId || postOwner === currentUser?.id) && (
                            <div className="flex gap-1 flex-shrink-0">

                              {/* EDIT - Mobile optimized */}
                              {currentUser?.id === c.userId && (
                                <button
                                  className="p-0.5 sm:p-1 text-gray-400 hover:text-gray-600"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleEditComment(c);
                                  }}
                                >
                                  <svg className="w-3 h-3 sm:w-3.5 sm:h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                  </svg>
                                </button>
                              )}

                              {/* DELETE - Mobile optimized */}
                              <button
                                className="p-0.5 sm:p-1 text-gray-400 hover:text-red-500"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDeleteComment(c.id);
                                }}
                              >
                                <svg className="w-3 h-3 sm:w-3.5 sm:h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                              </button>

                            </div>
                          )}
                        </div>

                        {editingCommentId === c.id ? (
                          <div className="mt-2">
                            <input
                              className="w-full p-1.5 sm:p-2 border border-gray-300 rounded-lg text-xs sm:text-sm"
                              type="text"
                              value={editComment}
                              onChange={(e) => setEditingComment(e.target.value)}
                            />
                            <div className="flex gap-2 mt-2">
                              <button
                                className="px-2 sm:px-3 py-1 bg-[#0f6abf] text-white text-xs sm:text-sm rounded-lg"
                                onClick={() => saveEditComment(c.id)}
                              >
                                Save
                              </button>
                              <button
                                className="px-2 sm:px-3 py-1 bg-gray-200 text-gray-700 text-xs sm:text-sm rounded-lg"
                                onClick={() => setEditingCommentId(null)}
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        ) : (
                          <p className="text-xs sm:text-sm text-gray-700 break-words">{c.text}</p>
                        )}
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>

        {/* Sticky comment input - Mobile optimized */}
        <div className="sticky bottom-0 bg-white pt-2 pb-3 sm:pt-3 sm:pb-4 border-t border-gray-200">
          <div className="flex items-center gap-2 sm:gap-3 px-3 sm:px-4">
            <img
              src={currentUser?.profile_picture}
              alt="Me"
              className="w-8 h-8 sm:w-9 sm:h-9 rounded-full object-cover border border-gray-200"
              onClick={()=>navigate("/profile-view")}
            />
          <form onSubmit={(e) => {
  e.preventDefault();
  e.stopPropagation(); // Add this line
  handleComment();
}} className="flex-1 flex gap-2">
              <input
                className="flex-1 px-3 sm:px-4 py-2 sm:py-2.5 border border-gray-300 rounded-full text-xs sm:text-sm focus:outline-none focus:border-[#0f6abf]"
                type="text"
                value={commentText}
                onChange={(e) => setCommentText(e.target.value)}
                placeholder="Write a comment..."
                 onClick={(e) => e.stopPropagation()} // Add this line
              />
              <button
                className="px-3 sm:px-5 py-2 sm:py-2.5 bg-[#0f6abf] text-white text-xs sm:text-sm font-medium rounded-full whitespace-nowrap"
                type="submit"
                disabled={postingComment} 
              >
               {postingComment ? "Posting..." : "Post"}
              </button>
            </form>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>,
  document.body
);
};

export default PublicModalView;